import * as React from "react";
import CreditCardInfoChangeFinishPage from "../pages/CreditCardInfoChangeFinish";
import { useDispatch } from "react-redux";
import { paymentActions } from "../store/payment";
import { useOnceCall } from "../custom-hooks/once-call";

const CreditCardInfoChangeFinishContainer = () => {
    const dispatch = useDispatch();
    useOnceCall(() => {
        dispatch(paymentActions.isChangeCardInfoInProgressSet(false));
    });
    return <CreditCardInfoChangeFinishPage />;
};

export default CreditCardInfoChangeFinishContainer;
